import { render } from "./ShippingDetails.vue?vue&type=template&id=f28da9cc&ts=true"
import script from "./ShippingDetails.vue?vue&type=script&lang=ts"
export * from "./ShippingDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__